module.exports = __webpack_public_path__ + "files/4bbdf561db5dfff41da5cd10df5a41fd.png";